import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

const getAuthHeaders = () => {
  const token = localStorage.getItem("clerkToken");
  return {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
};

export const fetchPortfolioHealth = () =>
  axios
    .get(`${BASE_URL}/dealership/portfolio-health`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchDealershipInventory = () =>
  axios
    .get(`${BASE_URL}/dealership/inventory`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const removeVehicleFromInventory = (vin) =>
  axios
    .delete(`${BASE_URL}/dealership/inventory/${vin}`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const addVehicleToInventory = (vehicleData) => {
  // Build payload according to API specification
  const payload = {
    vin: vehicleData.vin,
    price: vehicleData.price,
    mileage: vehicleData.mileage,
  };
  
  // Add optional fields only if they exist
  if (vehicleData.dom !== undefined && vehicleData.dom !== null && vehicleData.dom !== "") {
    payload.dom = vehicleData.dom;
  }
  
  if (vehicleData.photo) {
    payload.photo = vehicleData.photo;
  }
  
  return axios
    .post(`${BASE_URL}/dealership/inventory`, payload, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};



